import React from 'react';
import styles from './Header.module.css';

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles['header-content']}>
        <a 
          href="https://foldsofhonor.org" 
          className={styles['logo-link']}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/logo.png" alt="Folds of Honor" className={`${styles['logo-image']} ${styles['logo-desktop']}`} />
          <img src="/logo-mobile.png" alt="Folds of Honor" className={`${styles['logo-image']} ${styles['logo-mobile']}`} />
        </a>
        
        <button className={styles['menu-button']} aria-label="Menu">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
      </div>
    </header>
  );
};

export default Header;
